(function ($) {
    'use strict';
    $(document).ready(function () {
        var renderNoResults = function () {
            return $('<div>').html('<em>No results found</em>');
        };

        $('form .query-completion-trigger').autocompletion({
            datasets: {
                suggestion: {
                    collection: 'ncver-search',
                    profile: '_default',
                    program: 'https://ncver-search.squiz.cloud/s/suggest.json',
                    template: {
                        notFound: renderNoResults(),
                        header: $('<div>').html('<h3 class="ncver-tt_title--darkblue">Suggestions</h3>')
                    }
                },
                research: {
                    collection: 'ncver-search',
                    profile: 'researchAndStatistics-ac',
                    program: 'https://ncver-search.squiz.cloud/s/suggest.json',
                    template: {
                        notFound: renderNoResults(),
                        header: $('<div>').html('<h3 class="ncver-tt_title--purple">Research & Statistics</h3>')
                    }
                },
                rto: {
                    collection: 'ncver-search',
                    profile: 'rtoHub-ac',
                    program: 'https://ncver-search.squiz.cloud/s/suggest.json',
                    template: {
                        notFound: renderNoResults(),
                        header: $('<div>').html('<h3 class="ncver-tt_title--lightblue">RTO Hub</h3>')
                    }
                },
                news: {
                    collection: 'ncver-search',
                    profile: 'newsAndEvents-ac',
                    program: 'https://ncver-search.squiz.cloud/s/suggest.json',
                    template: {
                        notFound: renderNoResults(),
                        header: $('<div>').html('<h3 class="ncver-tt_title--darkblue">News & Events</h3>')
                    }
                },
                other: {
                    collection: 'ncver-search',
                    profile: 'otherInformation-ac',
                    program: 'https://ncver-search.squiz.cloud/s/suggest.json',
                    template: {
                        notFound: renderNoResults(),
                        header: $('<div>').html('<h3 class="ncver-tt_title--darkblue">Other Information</h3>')
                    }
                }
            },
            length: 3,
            typeahead: { hint: true },
            show: '5'
        });

    });
}(jQuery));